module.exports = {"endVisit":"Zakończ wizytę","close":"Zamknij","birthday":"Data urodzenia","gender":"Płeć","male":"Mężczyzna","female":"Kobieta","pesel":"PESEL","streetAddress":"Adres","city":"Miejscowość","postCode":"Kod pocztowy","patientHistory":"Historia pacjenta","attachmentsList":"Lista załączników","patient":"Pacjent","attachments":"Załączniki","invalidToken":"Niepoprawny Token \n Prosimy ponownie zalogować się do systemu","businessName":"Podmiot udzielający świadczeń zdrowotnych","signature":"Podpis"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/pl.json
// module id = M6kd
// module chunks = 1